import React from 'react';
import {BaseLayoutProps} from '../types';
import {
  getStaticDefaultsForStyleCategories,
  injectGlobalStyle,
} from '../../base/functions';
import {BaseLayoutStyleCategories} from './BaseLayoutStyleCategories';
import {useBaseLayoutProps} from '../hooks';

export const BaseLayout: React.FC<BaseLayoutProps> = props => {
  const {disabled, onPress, onBlur, children} = props;
  const {classNameProp, handleClick} = useBaseLayoutProps(props);

  return onPress ? (
    <button
      {...classNameProp}
      disabled={disabled}
      onClick={handleClick}
      onBlur={onBlur}>
      {children}
    </button>
  ) : (
    <div {...classNameProp} onBlur={onBlur}>
      {children}
    </div>
  );
};

// Turn off borders for all buttons
injectGlobalStyle({
  default: {
    '*button': {
      borderStyle: 'none',
      margin: 0,
      padding: 0,
      textDecoration: 'none',
      cursor: 'pointer',
      textAlign: 'left',
      '-webkit-appearance': 'none',
      '-moz-appearance': 'none',
      ':focus': {
        outline: 'none',
      },
      ':active:not([disabled])': {
        opacity: '0.5',
      },
    },
    '*.di-div': {
      backgroundColor: 'unset',
      display: 'flex',
      ...getStaticDefaultsForStyleCategories(BaseLayoutStyleCategories),
    },
  },
});
